import {TRole} from '../declarations';
import {ROLES} from '../enums';
import {NEW_PERSONAL_URL} from './common.constant';
import {ROUTES} from './routes.constant';

export interface ITextByRole {
  id: number;
  // role: "" - default value
  role: string;
  value: string;
}

interface IHeaderMenuItem {
  id: number;
  textByRole: ITextByRole[];
  link: string;
  roles: TRole[];
  newPersonal: boolean;
}

export const HEADER_MENU_ITEMS: IHeaderMenuItem[] = [
  {
    id: 2,
    textByRole: [
      {
        id: 1,
        role: '',
        value: 'MENU.PROFILE',
      },
    ],
    link: `${NEW_PERSONAL_URL}${ROUTES.PROFILE.MY}`,
    roles: [],
    newPersonal: true,
  },
  {
    id: 3,
    textByRole: [
      {
        id: 1,
        role: '',
        value: 'MENU.ORDERS',
      },
    ],
    link: `${NEW_PERSONAL_URL}${ROUTES.ORDERS.MY}`,
    roles: [],
    newPersonal: true,
  },
  {
    id: 4,
    textByRole: [
      {
        id: 1,
        role: '',
        value: 'MENU.PROJECTS',
      },
    ],
    link: `${NEW_PERSONAL_URL}${ROUTES.PROJECTS.MY}`,
    roles: [ROLES.DEVELOP, ROLES.CLIENT, ROLES.MANAGER, ROLES.ADMIN],
    newPersonal: true,
  },
  {
    id: 6,
    textByRole: [
      {
        id: 1,
        role: ROLES.HEAD_MANAGER,
        value: 'MEETINGS.MANAGER_MEETINGS_TITLE',
      },
      {
        id: 2,
        role: ROLES.MANAGER,
        value: 'MEETINGS.MEETINGS_WITH_CLIENTS_TITLE',
      },
      {
        id: 3,
        role: ROLES.CLIENT_SUPPORT,
        value: 'MEETINGS.MEETINGS_WITH_CLIENTS_TITLE',
      },
      {
        id: 4,
        role: '',
        value: 'MEETINGS.MEETINGS_TITLE',
      },
    ],
    link: '/meetings',
    roles: [],
    newPersonal: false,
  },
];
